/* eslint-disable react/prop-types */
/* eslint-disable import/prefer-default-export */

/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import "lazysizes";

import React from "react";
import AppProvider from "~context/AppContext";
import DocumentProvider from "~context/DocumentContext";
import Nav from "~components/Nav";
import Notification from "~components/Notification";

import "~scss/index.scss";

export const wrapRootElement = ({ element }) => {
  return (
    <>
      <DocumentProvider>
        <AppProvider>
          <Nav />
          <Notification />

          {element}
        </AppProvider>
      </DocumentProvider>
    </>
  );
};
